export default __webpack_public_path__ + "static/media/029-couple.4313f030.png";